var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoContractualesLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.06 117.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #232a61;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "message",
    className: "cls-1",
    d: "M13.7,105.15c-7.53,0-13.64-6.1-13.64-13.63H.06v-22.74c0-.69.16-1.37.46-1.99l15.71-35.34c2.18-4.93,7.07-8.12,12.47-8.11h42.73c5.4,0,10.29,3.17,12.48,8.11l15.77,35.49c.26.58.39,1.21.39,1.84v22.73c0,7.53-6.1,13.63-13.63,13.64H13.7ZM9.15,91.52c0,2.51,2.03,4.54,4.54,4.55h72.73c2.51,0,4.55-2.04,4.55-4.55v-18.17h-20.29l-7.74,11.61c-.84,1.27-2.26,2.03-3.78,2.02h-18.18c-1.52,0-2.94-.75-3.78-2.02l-7.74-11.61H9.16v18.17ZM31.88,64.25c1.52,0,2.94.76,3.78,2.02l7.74,11.61h13.32l7.74-11.61c.84-1.26,2.26-2.02,3.78-2.02h20.28l-12.93-29.11c-.73-1.64-2.36-2.7-4.16-2.7H28.7c-1.8,0-3.43,1.06-4.16,2.7l-12.93,29.11h20.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoContractualesLight);
export default __webpack_public_path__ + "static/media/icono-contractuales-light.7b6a4253ac51b0937095ccc0b9856bcd.svg";
export { ForwardRef as ReactComponent };